import { useMarketDataGraphqlAction } from './actions/useMarketDataGraphAction';

export const GlobalHooks = () => {
  useMarketDataGraphqlAction();

  return null;
};
